import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react.jsx';

const allevaOrange = allevaOrangeColor[0];

/* Call something like this
    <ReferralCategoryDropdown
      value={'Word of Mouth'}
      onChange={(referralCategory) => this.setState({ chosenReferralCaegory: referralCategory })}
    />
 */

const styles = (theme) => ({
  root: {},
});

class ReferralCategoryDropdown extends React.Component {
  constructor(props) {
    super(props);
  }

  categoryOptions = [
    'Company / Organization',
    'Word of Mouth',
    'Internet Search',
    'Social Media',
    'Media',
    'Marketing Event/Campaign',
    'Unknown',
  ];

  render() {
    const { classes } = this.props;

    let label = 'Referral Type';
    if (this.props.required) {
      label += ' *';
    }

    const inputLabelProps = this.props.required ? { style: { color: allevaOrange } } : {};

    return (
      <Autocomplete
        className={classes.root}
        blurOnSelect={true}
        options={this.categoryOptions}
        getOptionLabel={(option) => option}
        value={this.props.value}
        renderInput={(params) => (
          <TextField {...params} label={label} InputLabelProps={inputLabelProps} variant="standard" />
        )}
        onChange={(event, value) => this.props.onChange(value)}
      />
    );
  }
}

export default withStyles(styles)(ReferralCategoryDropdown);
